// better-auth React client. Dev: baseURL is the same origin (Vite proxies to the
// API). Prod: VITE_API_URL points at the API origin (same-site subdomain), so the
// session cookie is still sent on credentialed requests.

import { createAuthClient } from 'better-auth/react';
import { API_BASE } from './apiBase';

export const authClient = createAuthClient({
  baseURL: API_BASE,
});

export const { signIn, signUp, signOut, useSession } = authClient;
